// extracted by mini-css-extract-plugin
export default {"header":"SO","container":"TO","accordeonitem":"UO","itemsticky":"VO","itemopen":"WO","open":"XO","productname":"YO","productinfo":"ZO","flavorstext":"aP","invalidlimit":"bP","limit":"cP","scrollUpAccordion":"eP","wrapper":"fP"};
    if(module.hot) {
      // 1713912566705
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  